import { Helmet } from 'react-helmet'
import imageRedWine from '../../assets/images/menuRedWine.png'
import imageWhiteWine from '../../assets/images/menuWhiteWine.png'
import imageBeer from '../../assets/images/menuBeer.png'
import imageLiquor from '../../assets/images/menuLiquor.png'
import award from '../../assets/images/spectator23.jpg'

// KPKP --- CHANGE DRINK MENU IN PUBLIC && SRC !!!!

export default function DrinkMenu(){
  return (
    <div className="pageStyles drink-menu">
      <Helmet>
        <title>Enjoy a Cocktail at Villaggio Grille</title>
        <meta name="description" content="Come enjoy a cold drink at Villaggio Grille. Let our bartenders entertain you for a while, or grab a drink to walk the docks of the Wharf's marina with. Either way, include our drink menu in your day, and you won't be sorry!" />
      </Helmet>

      <div id="menupage" className="nodrops">
        <div id="page-title" className="pt-bkg-image image-bottle">
          <div className="overlay">
            <div className="title-container less">
              <section className="fancy-heading center">
                <h1>Drink Menu</h1>
              </section>
            </div>
          </div>
        </div>

        <div className="page-content food-menus">
          <div className="fullSec newLay">
            <div className="kpWrapXl sectionWrap">
              <div className="feature group cbp-item">
                <p className="instr text-center">Click any menu image below to see a larger version.</p>
                <div id="redWine" className="cbp-caption second">
                  <div className="cbp-l-caption-body menuLink">
                    <a href={`../../DrinkMenu.pdf#page=2`} target="_blank" rel="noopener noreferrer" className="menuPageLink">
                      <img src={imageRedWine} alt="Villaggio's Red Wine List" className="border" />
                    </a>
                    <a href={`../../DrinkMenu.pdf`} target="_blank" rel="noopener noreferrer" className="menuPageLink">
                      <img src={imageWhiteWine} alt="Villaggio's White Wine List" className="border" />
                    </a>
                    <a href={`../../DrinkMenu.pdf#page=3`} target="_blank" rel="noopener noreferrer" className="menuPageLink">
                      <img src={imageBeer} alt="Villaggio Beer and Drink Menu, Orange Beach, AL restaurant" className="border" />
                    </a>
                    <a href={`../../DrinkMenu.pdf#page=4`} target="_blank" rel="noopener noreferrer" className="menuPageLink">
                      <img src={imageLiquor} alt="Villaggio cordials list" className="border" />
                    </a>
                  </div>
                </div>
              </div>

              <div className="side stickyNn group fwImage_xx">
                <div className="kpWrap sideWrap">
                  <h4 className="text-center">Villaggio Grille is the Wine Spectator Award Winner of: 2009, 2010, 2011, 2012, 2013, 2015, 2021, 2023</h4>
                  <a href="https://www.winespectator.com/restaurants/1568/villaggio-grille" target="_blank" rel="noreferrer" className="specImg">
                    <img src={award} alt="Villaggio's wine spectator award" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xs-12"><div className="hr hr-png-10"></div></div>
    </div>
  )
}
